import type {
	StaffFunctionValue,
	StaffMemberPayload,
} from '@Application/Facilities/StaffMembers/StaffMembers/Actions/staffMembersFetched';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * `facilityIds` is derived from the payload's `{ id }`-only relation (`UserView.facilityIds` is the
 * same shape): the server never sends a name, so no getter here fabricates one — the page resolves
 * names from the organization's agencies it already loads (`resolveFacilityNames`).
 */
class StaffMemberView {
	readonly id: number;
	readonly firstName: string;
	readonly lastName: string;
	readonly jobFunction: StaffFunctionValue;
	readonly phoneNumber: string | null;
	readonly email: string | null;
	readonly facilityIds: readonly number[];
	readonly linkedBeneficiaryCount: number;

	constructor(payload: StaffMemberPayload) {
		this.id = payload.id;
		this.firstName = payload.firstName;
		this.lastName = payload.lastName;
		this.jobFunction = payload.jobFunction;
		this.phoneNumber = payload.phoneNumber;
		this.email = payload.email;
		this.facilityIds = payload.facilities.map((facility) => facility.id);
		this.linkedBeneficiaryCount = payload.linkedBeneficiaryCount ?? 0;

		Object.freeze(this);
	}

	get fullName(): string {
		return `${this.firstName} ${this.lastName}`;
	}
}

export default StaffMemberView;
